import { Component, Input } from '@angular/core';
import { User } from '../../shared/shared.model';

@Component({
  selector: 'iaud-home-title',
  templateUrl: './home-title.component.html',
  styleUrls: ['./home-title.component.scss']
})
export class HomeTitleComponent {
  @Input()
  user: User = {id: 1, email: '', username: 'john', fullName: 'Sapto Priyono'};  
  @Input()  
  loginName : String = "Sapto Priyono";
  @Input()
  taskCount: number = 5;  
  date: Date = new Date();
}
